var L10N = {
    lang: ['en'],
    getString: function (id) {
        for (var i = 0; i < L10N.lang.length; i++) {
            var lang = L10N.lang[i];
            if ((lang in LOCALE) && (id in LOCALE[lang])) {
                return LOCALE[lang][id];
            }
        }
        return DEBUG ? '{' + id + '}' : '';
    },
    hasString: function (id) {
        if (!LOCALE) {
            return false;
        }
        for (var i = 0; i < L10N.lang.length; i++) {
            var lang = L10N.lang[i];
            if ((lang in LOCALE) && (id in LOCALE[lang])) {
                return true;
            }
        }
        return false;
    },
    setLang: function (lang) {
        L10N.lang.unshift(lang);
    }
};

